import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import CancelIcon from '@material-ui/icons/Cancel';
import TextField from "@material-ui/core/TextField";
import { useStoreActions } from 'easy-peasy';



export const TagChips = ({
    name,
    errors,
    touched,
    setTouched,
    setFieldValue,
  placeholder,
    initData,
    isDisabled,
    maxTags,
    textCase,
    firstReadOnly,
    readonly,
    hiddenItems,
    setHiddenItems,
},
    ...props
) => {
  
  const [value, setValue] = React.useState([]);

  const commonAction = useStoreActions((actions) => actions.common);

  React.useEffect(() => {
    if (initData)
    setValue(initData);
  },[initData])
    const [inputValue, setInputValue] = React.useState("");

    const handleChange = (event, tags) => {

      if (tags.length <= maxTags) {
        setTouched({ ...touched, [name]: true });
        setValue(tags);
        // event.persist();
        setFieldValue(name, tags);
      }
      else {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: `Can't add more than ${maxTags} values`,
          error: true,
      });
      }
        
    };

    const handleInputChange = (event, newInputValue) => {
      
        setInputValue(newInputValue);

        // if (options.trim().length === 0) {
        //     handleChange(event, fieldValue);
        // } else {
        //     setInputValue(newInputValue);
        // }
    };

    const handleKeyDown = (event) => {
        switch (event.key) {
            case "Enter":
            case "Tab": {
                if (inputValue.length > 0) {

                  if (hiddenItems.includes(inputValue)) {
                    hiddenItems.splice(hiddenItems.indexOf(inputValue), 1);
                  }


                  if (setHiddenItems !== null) {
                    console.log('hiddenitems ==> ', hiddenItems)

                    setHiddenItems(hiddenItems);

                  }
                 
                  handleChange(event, value.concat([inputValue]));
                }
                break;
            }
            default:
        }
    };

    return (
    <Autocomplete
      multiple
      autoHighlight
      disableClearable={true}
      options={[]}
    freeSolo
      renderTags={(tags, getTagProps) =>
        tags.map((tag, index) => {
        
          return (readonly==true || (firstReadOnly===true && index==0 && tags.length > 1)) ? (
            <Chip
                key={`tag_chip_${index}`}
            variant="default"
            label={tag}
            style={{'textTransform': (textCase !=='') ?  textCase : 'none', 'display': ((hiddenItems.length > 0 && hiddenItems.includes(tag)) ? 'none' : 'inherit' ), 'marginRight': '3px'}}
          />
        ) : (
          
          <Chip
              key={`tag_chip_${index}`}
          deleteIcon={<CancelIcon />}
          variant="default"
          label={tag}
          {...getTagProps({ index })}
          style={{'textTransform': (textCase !=='') ?  textCase : 'none', 'display': ((hiddenItems.length > 0 && hiddenItems.includes(tag)) ? 'none' : 'inherit' ), 'marginRight': '3px'}}
        />
      ) } )
      }
      value={value}
      inputValue={inputValue}
      onChange={handleChange}
      onInputChange={handleInputChange}
      disabled={isDisabled} 
      renderInput={params => {
          params.inputProps.onKeyDown = handleKeyDown;

          if (textCase && textCase !== '') {
            params.inputProps.style = {};
            params.inputProps.style.textTransform = 'lowercase'
          }

          if (readonly===true) {
            params.inputProps.readOnly = true;
          }

        return (
            <TextField
                {...params}
                label={placeholder}
                name={name}
                variant="outlined"
                {...props}
                
                
          />
        );
      }}
    />
  );
};

TagChips.defaultProps = {
  "maxTags": 50,
  "textCase":{},
  "firstReadOnly": false,
  readonly: false,
  hiddenItems: [],
  setHiddenItems: null
}

